<!--保存快捷搜索的dialog-->
<template>
  <el-form
    ref="formRef"
    class="form"
    :inline="true"
    :model="formData"
    :rules="mapRules"
    @keydown.enter.prevent="submit"
  >
    <el-form-item prop="name" label="快捷筛选名称">
      <el-input
        v-model="formData.name"
        maxlength="8"
        placeholder="请输入"
        show-word-limit
      >
      </el-input>
    </el-form-item>
  </el-form>
</template>

<script setup lang="ts">
import { ref, reactive } from 'vue';
import {
  ElForm,
  ElFormItem,
  ElInput,
  FormRules,
  FormInstance
} from 'element-plus';
import { PopupCtx, usePopup } from '../../core/EasyPopup';
import { IgnoreError } from '../../core/Errors';

const props = defineProps<{
  existItems: string[]; // 已存在的搜索

  popupCtx?: PopupCtx<string>; // popup支持
}>();
const popup = usePopup(props);

const validatePass = (rule: any, value: any, callback: any) => {
  if (props.existItems.length >= 30) {
    callback(
      new Error(
        '快捷筛选已达到上限，如需添加，请先删除部分不使用的快捷筛选标签后再来保存！'
      )
    );
  } else if (props.existItems.find((item) => item == value)) {
    callback(new Error('名称已存在，不可重复，请重命名后再保存'));
  } else {
    callback();
  }
};

const mapRules = reactive<FormRules>({
  name: [
    { required: true, message: '需要输入名称后才能执行保存', trigger: 'blur' },
    { validator: validatePass, trigger: 'blur' }
  ]
});

const formData = reactive({
  name: ''
});

const formRef = ref<FormInstance>();

const submit = async () => {
  try {
    if (await formRef.value?.validate()) {
      popup.done(formData.name);
    }
  } catch (e) {
    throw new IgnoreError('ValidateFail', e);
  }
  return false;
};

popup.resultDef(submit);
</script>

<style lang="scss" scoped>
.form {
  .el-form-item {
    box-sizing: border-box;
    position: relative;
    top: 50%;
    margin: 0;
    width: 100%;
    padding-right: 10px;
  }

  :deep(.el-input__wrapper),
  :deep(.el-input__wrapper:hover) {
    box-shadow: 0 0 0 1px var(--el-input-border-color, var(--el-border-color))
      inset !important;
  }
}
</style>
